import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';

import { AttachmentDocument } from '@shared/models';
import { WorkflowService } from '@shared/services';

import { LoadingScreenComponent } from '../loading-screen/loading-screen.component';

@Component({
  selector: 'app-attachment-preview-modal',
  templateUrl: './attachment-preview-modal.component.html',
  styleUrls: ['./attachment-preview-modal.component.scss'],
  standalone: true,
  imports: [NgxExtendedPdfViewerModule, RktIconComponent, NgIf, LoadingScreenComponent],
})
export class AttachmentPreviewModalComponent {
  workflowService = inject(WorkflowService);
  activeModal = inject(ActiveModal);

  attachment!: AttachmentDocument;

  documentPagesCount?: number;

  isScrolledToTheEnd = false;

  isPdf = false;

  hasLoadError = false;

  isLoading = false;

  modalInitData(attachment: AttachmentDocument) {
    this.attachment = attachment;
    this.isPdf = attachment.extension?.toUpperCase() === 'PDF';
    this.hasLoadError = false;
    this.isLoading = this.isPdf;
  }

  onPageChange(page: number): void {
    if (page === this.documentPagesCount) {
      this.isScrolledToTheEnd = true;
    }
  }

  onPagesLoaded({ pagesCount }: { pagesCount: number }): void {
    this.documentPagesCount = pagesCount;
  }

  onPdfLoaded(): void {
    this.isLoading = false;
  }

  // pdf.js puts the full (signed) document url in the message, so only the error type and status are logged.
  onPdfLoadingFailed(error: Error & { status?: number }): void {
    console.error('Attachment preview failed to load', error.name, error.status);
    this.isLoading = false;
    this.hasLoadError = true;
  }

  onImageError(): void {
    this.hasLoadError = true;
  }

  onDownloadClick(attachment: AttachmentDocument): void {
    this.workflowService.downloadAttachment(attachment);
  }
}
